import 'bootstrap/js/dist/collapse';

import { initializeMobileNavToggle } from './mobile-nav-toggle.js';
import { initializeHeaderSearch } from './header-search';
import { inititializeDynamicPaddingForMainContent } from './dynamic-padding-for-main-content';
import { initializeSwiper } from './swiper';

document.addEventListener('DOMContentLoaded', () => {

	initializeMobileNavToggle();
	initializeHeaderSearch();
	inititializeDynamicPaddingForMainContent();
	initializeSwiper();
})
